<template>
	<p class="uppercase text-xs font-main-bold py-4" v-if="media">
		{{title}}

		<!-- Close button -->
		<img class="w-4 float-right mr-4 cursor-pointer" src="@/assets/images/close-icon.svg"
		v-if="closable"
		@click="$emit('close')">
	</p>
</template>

<script>
	export default {
		name: 'MediaPlayerHeader',
		props: {
			title: {
				type: String,
				required: false,
				default: null
			},
			media: {
				type: Object,
				required: true,
				default: null
			},
			closable: {
				type: Boolean,
				required: false,
				default: false
			},
		}
	}
</script>

<style lang="scss" scoped></style>
